import React, { useEffect, useState } from "react";
import * as viewReducer from "containers/View/reducer";
import { useDispatch, useSelector } from "types/store";
import * as globalReducer from "@/containers/App/reducer";
import styles from "@/components/LanguageModelArtifact/style.module.css";
import LoadingIndicator from "@/components/LoadingIndicator/LoadingIndicator";
import { Button, ButtonGroup } from "@/aible";
import { isEnabled } from "@/utils/featureFlags";
import DeploymentViewContainer from "@/containers/View/Deployment";
import Models from "@/components/LanguageModelArtifact/Models/Models";
import TrainingData from "@/components/LanguageModelArtifact/TrainingData/TrainingData";
import PublishModal from "@/components/CommunityMarket/PublishModal";
import * as fineTuningReducer from "@/containers/FineTuning/reducer";
import * as aiServiceReducer from "@/containers/AiService/reducer";
export var FineTuningViewState;
(function (FineTuningViewState) {
    FineTuningViewState["MODELS"] = "MODELS";
    FineTuningViewState["EVALUATION"] = "EVALUATION";
    FineTuningViewState["TRAINING_DATA"] = "TRAINING_DATA";
    FineTuningViewState["DEPLOYMENTS"] = "DEPLOYMENTS";
})(FineTuningViewState || (FineTuningViewState = {}));
const ArtifactView = () => {
    const dispatch = useDispatch();
    const downloadArtifactFeedback = (artifactId) => {
        dispatch(viewReducer.downloadArtifactFeedback(artifactId));
    };
    const [tabView, updateTabView] = useState(FineTuningViewState.MODELS);
    const isFineTuningLoading = useSelector((state) => globalReducer.getIsFineTuningLoading(state));
    const isExampleSetsLoading = useSelector((state) => globalReducer.getIsExampleSetsLoading(state));
    useEffect(() => {
        const intervalId = setInterval(() => {
            dispatch(fineTuningReducer.pollFineTuningExecutions());
            dispatch(aiServiceReducer.pollAiServiceModelStatus());
        }, 15000);
        return () => {
            clearInterval(intervalId);
        };
    }, []);
    if (isFineTuningLoading || isExampleSetsLoading) {
        return (React.createElement("div", { className: styles.loadingHolder },
            React.createElement(LoadingIndicator, null)));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.fineTuningPanel },
            React.createElement("div", { className: styles.tabActionsWrapper },
                React.createElement(ButtonGroup, null,
                    React.createElement(Button, { onClick: () => updateTabView(FineTuningViewState.MODELS), active: tabView === FineTuningViewState.MODELS, isSmall: true }, "Available Models"),
                    React.createElement(Button, { onClick: () => updateTabView(FineTuningViewState.TRAINING_DATA), active: tabView === FineTuningViewState.TRAINING_DATA, isSmall: true }, "Post Train and Evaluator Datasets"),
                    isEnabled("aible-optimize") && (React.createElement(Button, { onClick: () => updateTabView(FineTuningViewState.DEPLOYMENTS), active: tabView === FineTuningViewState.DEPLOYMENTS, isSmall: true }, "Deployed AI")))),
            tabView === FineTuningViewState.MODELS && React.createElement(Models, null),
            tabView === FineTuningViewState.TRAINING_DATA && (React.createElement(TrainingData, { downloadArtifactFeedback: downloadArtifactFeedback })),
            tabView === FineTuningViewState.DEPLOYMENTS && React.createElement(DeploymentViewContainer, { isDeploymentsTab: true })),
        isEnabled("community-market") && React.createElement(PublishModal, null)));
};
export default ArtifactView;
